export default "__VITE_ASSET__CBaUPKx7__"